import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const CTVModalContent = () => {
  const { t } = useTranslation();

  return (
    <DialogContent dividers>
      <Typography variant="body1" data-test="ctv-alert-message">
        {t('Video on TV devices and App is a CTV configuration. Do you want to change Format to CTV?')}
      </Typography>
    </DialogContent>
  );
};
